<template>
    <header>
      <div class="container">
        <div class="header-bar">
          <a class="header-logo" href="https://www.andesonline.com">
            <img class="main-logo img-fluid" src="@/img/andes_logo.jpg" :alt="$t('logo-andes')">
          </a>
          <div class="language-selector">
            <label for="sales-locale">{{ $t('Idioma') }}</label>
            <select id="sales-locale"
                    :value="locale"
                    @change="onLocaleChange">
              <option value="es">ES</option>
              <option value="en">EN</option>
            </select>
          </div>
        </div>
      </div>
    </header>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'andes-header',
    computed: {
      ...mapState(['locale']),
    },
    methods: {
      onLocaleChange(event) {
        this.$setLocale(event.target.value)
      },
    },
  }
</script>

<style scoped>
.header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}
.header-logo {
  display: inline-block;
  flex: 0 0 auto;
}
.language-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  margin-left: auto;
  z-index: 2;
}
.language-selector label {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
}
.language-selector select {
  min-width: 64px;
  height: 34px;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 13px;
  font-weight: 600;
}
</style>
